// ================================================================
// ContextMenu — منوی راست‌کلیک generic
// ================================================================

import './context-menu.css';
import { t } from '../../i18n/index.js';
import { icon, escapeHtml } from '../../utils/dom.js';
import { state } from '../../core/state.js';
import { events, EVENTS } from '../../core/events.js';
import { nodeRegistry } from '../../nodes/registry.js';

let menuEl = null;
let currentContext = null;

// آیتم‌های منو بر اساس context:
//   - فضای خالی canvas: افزودن نود آزاد
//   - روی اتصال (type === 'connection'): حذف اتصال
//   - روی نود (ctx.nodeId): حذف نود
function getMenuItems(ctx) {
  if (ctx.type === 'canvas') {
    return [
      {
        key: 'add-node',
        labelKey: 'context.addNode',
        icon: 'add',
        onClick: ({ canvasX, canvasY }) => {
          events.emit(EVENTS.MODAL_OPEN_PICKER, {
            fromNodeId: null,
            x: canvasX,
            y: canvasY
          });
        }
      }
    ];
  }

  if (ctx.type === 'connection') {
    return [
      {
        key: 'delete-connection',
        labelKey: 'context.deleteConnection',
        icon: 'delete',
        danger: true,
        onClick: ({ fromId, toId }) => {
          state.removeConnection(fromId, toId);
        }
      }
    ];
  }

  return [
    {
      key: 'delete',
      labelKey: 'context.delete',
      icon: 'delete',
      danger: true,
      onClick: ({ nodeId }) => {
        state.removeNode(nodeId);
      }
    }
  ];
}

export function initContextMenu(root) {
  menuEl = document.createElement('div');
  menuEl.className = 'context-menu hidden';
  root.appendChild(menuEl);

  events.on(EVENTS.CONTEXT_MENU_OPEN, openMenu);

  document.addEventListener('mousedown', (e) => {
    if (menuEl.classList.contains('hidden')) return;
    if (!menuEl.contains(e.target)) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !menuEl.classList.contains('hidden')) {
      closeMenu();
    }
  });

  window.addEventListener('scroll', closeMenu, true);

  menuEl.addEventListener('contextmenu', (e) => e.preventDefault());
}

function openMenu(ctx) {
  currentContext = ctx;
  const items = getMenuItems(ctx);

  menuEl.innerHTML = items.map(item => {
    const classes = [
      'context-menu-item',
      item.danger ? 'danger' : '',
      item.disabled ? 'disabled' : ''
    ].filter(Boolean).join(' ');

    return `
      ${item.divider ? '<div class="context-menu-divider"></div>' : ''}
      <button class="${classes}" data-key="${escapeHtml(item.key)}" ${item.disabled ? 'disabled' : ''}>
        <span class="context-menu-icon" ${item.iconColor ? `style="color: ${item.iconColor}"` : ''}>${icon(item.icon, 18)}</span>
        <span class="context-menu-label">${escapeHtml(t(item.labelKey))}</span>
      </button>
    `;
  }).join('');

  menuEl.querySelectorAll('.context-menu-item').forEach(btn => {
    const key = btn.dataset.key;
    const item = items.find(i => i.key === key);
    if (!item || item.disabled) return;
    btn.addEventListener('click', () => {
      item.onClick?.(currentContext);
      closeMenu();
    });
  });

  menuEl.classList.remove('hidden');
  const rect = menuEl.getBoundingClientRect();
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  let x = ctx.x;
  let y = ctx.y;

  if (x + rect.width > vw - 8) x = vw - rect.width - 8;
  if (y + rect.height > vh - 8) y = vh - rect.height - 8;

  menuEl.style.left = x + 'px';
  menuEl.style.top = y + 'px';
}

function closeMenu() {
  if (menuEl) menuEl.classList.add('hidden');
  currentContext = null;
}
